import {useContext} from "react";
import {UserInfoContext} from "../providers/UserProvider";

const useUserInfo = () => {
  const {
    fullName,
    role,
    email,
    firstName,
    lastName,
    firstTimeLogin,
    externalUserId,
    permissions,
    faOptions,
    notificationCount,
    setNotificationCount
  } = useContext(UserInfoContext);

  return {
    fullName,
    firstName,
    lastName,
    firstTimeLogin,
    externalUserId,
    role,
    email,
    permissions,
    faOptions,
    notificationCount,
    setNotificationCount
  }
}

export default useUserInfo;


// WEBPACK FOOTER //
// ./src/hooks/useUserInfo.js